///<amd-module name = "Core/Medius.Core.Web/Scripts/components/taskHandling/fraudPopup/FinalApprovalPopupInconclusiveTemplate"/>
import * as React from "react";
import { ConfirmDialog, Text } from "@medius/ui-controls";
import { getLabelTranslation } from "Core/Medius.Core.Web/Scripts/lib/globalization";

interface FinalApprovalPopupInconclusiveTemplateInterface {
    showPopup: boolean,
    onConfirm: () => void,
    onCancel: () => void,
}


export const FinalApprovalPopupInconclusiveTemplate = ({showPopup, onConfirm, onCancel}:FinalApprovalPopupInconclusiveTemplateInterface) => {
    return (<>
        <ConfirmDialog 
            isOpen={showPopup}
            cancelLabel={getLabelTranslation("#Core/cancel")}
            confirmLabel={getLabelTranslation("#Core/finalApprovalConfirmation")}
            data-testid="finalApprovalPopupInconclusive"
            onCancel={onCancel}
            onConfirm={onConfirm}>
            <Text data-testid="finalApprovalPopupInconclusive-title" variant="heading2">{getLabelTranslation("#Core/finalApprovalPopupInconclusiveTitle")}</Text>
            <Text data-testid="finalApprovalPopupInconclusive-text" variant="body">{getLabelTranslation("#Core/documentMayHaveUncalculatedRisks")}</Text>  
        </ConfirmDialog>
    </>);
};